import CardList from './component.jsx'

export default CardList
